import {
  GET_LABSEGMENT_FAIL,
  GET_LABSEGMENT_SUCCESS,
  GET_LABSEGMENTS_FAIL,
  GET_LABSEGMENTS_SUCCESS,
  ADD_LABSEGMENT_SUCCESS,
  ADD_LABSEGMENT_FAIL,
  UPDATE_LABSEGMENT_SUCCESS,
  UPDATE_LABSEGMENT_FAIL,
  DELETE_LABSEGMENT_SUCCESS,
  DELETE_LABSEGMENT_FAIL,  
  SET_STATE_LABSEGMENT
} from "./actionTypes";

const INIT_STATE = {
  labsegments: [],
  labsegment: {},
  error: {},
  loading: false,
  total: 0,
  currentPage: 0,
};

const labSegments = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_LABSEGMENTS_SUCCESS:
      return {
        ...state,
        labsegments: action.payload.labsegments,
        total: action.payload.total,
        currentPage: action.payload.currentPage,
      };

    case SET_STATE_LABSEGMENT:
      return { ...state, loading: action.payload }

    case GET_LABSEGMENTS_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case ADD_LABSEGMENT_SUCCESS:
      return {
        ...state,
        labsegments: [...state.labsegments, action.payload],
      };

    case ADD_LABSEGMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_LABSEGMENT_SUCCESS:
      return {
        ...state,
        labsegments: state.labsegments.map(labsegment =>
          labsegment.id.toString() === action.payload.id.toString()
            ? { ...action.payload, labsegment }
            : labsegment
        ),
      };

    case UPDATE_LABSEGMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_LABSEGMENT_SUCCESS:
      return {
        ...state,
        labsegments: state.labsegments.filter(
          labsegment => labsegment.id.toString() !== action.id.toString()
        ),
      };

    case DELETE_LABSEGMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    case GET_LABSEGMENT_SUCCESS:
      return {
        ...state,
        labsegment: action.payload,
      };

    case GET_LABSEGMENT_FAIL:
      return {
        ...state,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default labSegments;
